import { css } from '@emotion/react';
import colors from '../../../Themes/colors';
import fonts from '../../../Themes/fonts';

export const orderSummaryContainer = css({
    padding: '32px',
    backgroundColor: colors.white,
    marginTop: '40px',
    border: '1px solid #E6DFD8',
    borderRadius: '8px',

});

export const orderSummaryTitle = css({
    color: colors.black,
    fontSize: 24,
    fontWeight: 700,
    fontFamily: 'Playfair',
});

export const orderSummaryText = css({
    ...fonts.orderSummaryText,
    fontSize: '16px',
    color: colors.black,
    paddingRight: '0px',
    fontFamily: 'Acumin VF',
    fontWeight: 500,

    '@media(min-width:576px)': {
        fontSize: '16px',
    },

    '@media(min-width:1400px)': {
        fontSize: '18px',
    },
});

export const orderSummaryColumnRight = css({
    textAlign: 'end',
    paddingLeft: '0px',
    paddingRight: '15px',
});

export const orderSummaryRows = css({
    marginTop: '20px',
    '& .css-1p4rmct-OrderHistorySubItem': {
        width: '100%',
        padding: '15px',
    },

    '& .css-ps4swk-OrderHistorySubItem': {
        font: '18px Archivo-Medium, sans-serif',
        color: colors.black,
    },

    '& .css-ue6dge-OrderHistorySubItem, & .css-lvnu5m-OrderHistorySubItem': {
        fontSize: '16px',
        color: colors.black,
    },
});

export const checkBoxContainer = css({
    display: 'flex',
    alignItems: 'center',
    font: '15px Archivo-Regular, sans-serif',
    color: colors.black,
});

export const saveAccountContainer = css({
    borderRadius: '5px',
    backgroundColor: colors.lightbrown,
    padding: '20px',
    width: '100%',
    margin: '2.4em 15px',

    '@media(min-width:768px)': {
        padding: '30px 50px',
        margin: '2.4em 0px',
    },
});

export const saveAccountTitle = css({
    ...fonts.saveAccountTitle,
    color: colors.black,
});

export const saveAccountText = css({
    font: '16px Archivo-Regular, sans-serif',
    color: colors.black,
    marginTop: '0.4em',
});

export const saveAccountLabel = css({
    font: '16px Archivo-Regular, sans-serif',
    color: colors.black,
    marginTop: '1.2rem',
});

export const continuePaymentButton = css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    font: '18px Archivo-Regular, sans-serif',
    color: colors.white,
    padding: '15px 40px',
    backgroundColor: '#064E72',
    margin: '15px 15px 1.2em',
    height: 54,
    width: '100%',
    borderRadius: '8px',

    '&:hover,&:focus': {
        border: '2px solid #064E72',
        backgroundColor: colors.white,
        fill: colors.white,
        color: '#064E72',
    },
});

export const ContinueButtonIcons = css({
    width: '25px',
    height: '25px',
    marginLeft: '15px',
    color: 'unset',

    '@media(min-width:992px)': {
        width: '25px',
        height: '25px',
        marginTop: -5,
    },
});

export const continuePaymentButtonLoading = css({
    font: '18px Archivo-Regular, sans-serif',
    color: '#064E72',
    padding: '15px 40px',
    border: '2px solid #064E72',
    backgroundColor: colors.white,
    margin: '15px 0px 1.2em',
    height: 54,
    width: '100%',

    '&:hover,&:focus': {
        backgroundColor: colors.primary,
        color: colors.white,
        border: `2px solid ${colors.primary}`,
    },
});
